export default __webpack_public_path__ + "static/media/storages_logo.c822e5e9.svg";